module.exports = __webpack_public_path__ + "img/covidvaccine_e.0612d434.jpg";